// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Пропозиції до консультацій» (Consultation Submissions, ключ `csb`, група `advocacy`). */
export const consultationSubmissionsManifest: IModuleManifest = {
  key: 'csb',
  group: 'advocacy',
  slug: 'consultation-submissions',
  prefix: 'CSB',
  name: { en: 'Consultation Submissions', uk: 'Пропозиції до консультацій' },
  entities: [
    { key: 'csb', slug: 'csb', name: { en: 'Consultation Submissions', uk: 'Пропозиції до консультацій' }, main: true },
    { key: 'consultation_submission', slug: 'consultation-submission', name: { en: 'Consultation Submissions', uk: 'Пропозиції до консультацій' }, main: false },
    { key: 'consultation_signatory', slug: 'consultation-signatory', name: { en: 'Consultation Signatories', uk: 'Підписанти' }, main: false },
    { key: 'consultation_summary', slug: 'consultation-summary', name: { en: 'Consultation Summaries', uk: 'Підсумки' }, main: false },
  ],
  loadState: () => import('./state/consultationSubmissionsSlice').then((m) => m.consultationSubmissionsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
